import React, { useState, useContext, useEffect } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { roleList, checkAccess } from '../roles-helper'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faInfoCircle, faUser, faReceipt } from '@fortawesome/free-solid-svg-icons'
import DashboardContext from '../layout/dashboard-context' 

const DashboardHeader: React.FC = () => {
  const [menuItems, setMenuItems] = useState([])
  const navigate = useNavigate()
  const location = useLocation()

  const { selectedOrganization } = useContext(DashboardContext)

  useEffect(() => {
    avalibleMenuOptions()
  }, [])

  const avalibleMenuOptions = () => {
    const menuOptions = ['UsersPage', 'BillingInfo', 'GuaranteedAmountPage']
    const items = []

    roleList.forEach((role) => {
      if (menuOptions.includes(role.name)) {
        checkAccess(role.name, selectedOrganization?.roles) && items.push(role)
      }
    })

    setMenuItems(items)
  }

  return (
    <div className="flex initial flex-row justify-between items-center gap-2 py-2 px-6 card">
      <div className="flex initial flex-row justify-start items-center gap-2">
        {selectedOrganization && selectedOrganization.id !== '' && (
          <div className="flex initial flex-col justify-center items-start">
            <p className="font-semibold text-darkBlue" style={{ fontSize: '24px' }}>
              {selectedOrganization.name}
            </p>
            <p className="text-md font-semibold text-darkBlue">{selectedOrganization.orgNr}</p>
          </div>
        )}
      </div>
      <div className="flex initial flex-col md:flex-row justify-between items-end gap-2 bg-white p-2">
        {selectedOrganization &&
          menuItems &&
          menuItems.map((path) => (
            <button
              key={path.name}
              onClick={() => navigate(path.path)}
              className={location.pathname === path.path ? 'btn-active btn-sm-sx' : 'btn btn-sm-sx'}
            >
              {path.icon === 'faReceipt' && <FontAwesomeIcon icon={faReceipt} className="mr-4" />}
              {path.icon === 'faUser' && <FontAwesomeIcon icon={faUser} className="mr-4" />}
              {path.icon === 'faInfoCircle' && (
                <FontAwesomeIcon icon={faInfoCircle} className="mr-4" />
              )}
              {path.label}
            </button>
          ))}
      </div>
    </div>
  )
}

export default DashboardHeader
